var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccordionDetails, AccordionSummary, Accordion as MUIAccordion, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import clsx from 'clsx';
import styles from './accordion.module.css';
export const Accordion = (_a) => {
    var { variant = 'default', title, children, id, className, noBorder } = _a, props = __rest(_a, ["variant", "title", "children", "id", "className", "noBorder"]);
    return (_jsxs(MUIAccordion, Object.assign({ role: "region", className: clsx(className, styles.accordionWrapper, {
            [styles.noBorder]: !!noBorder,
        }) }, props, { children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { className: styles.linkIcon }), "aria-controls": "panel1a-content", id: `${id}-header`, children: title }), _jsx(AccordionDetails, { id: `${id}-details`, className: variant === 'default'
                    ? styles.accordionDetails
                    : styles.accordionDetailsContained, "aria-labelledby": `${id}-details`, children: children })] })));
};
